export const playlistKeys = {
  detail: (id: number) => ["playlists", "detail", id] as const,
  songs: (id: number) => ["playlists", "songs", id] as const,
};

export const sharedPlaylistKeys = {
  detail: (token: string) => ["user-playlists", "shared", token] as const,
  items: (token: string) => ["user-playlists", "shared", token, "items"] as const,
};
